export default {
    "en": {
        "rent": {
            "punctual_state": {
                "upcoming": "Upcoming",
                "due": "Due",
                "late": "Late",
                "written_off": "Written-off",
                "completed": "Completed"
            }
        },
        "stripe": {
            "errors": {
                "api_connection_error": "Failure to connect to Stripe's API.",
                "api_error": "Stripe API errored.",
                "authentication_error": "Failed to authenticate with Stripe.",
                "card_error": "Error processing payment.",
                "invalid_request_error": "Invalid Stripe request parameters.",
                "rate_limit_error": "Too many Stripe API requests.",
                "validation_error": "Stripe validation error."
            },
            "codes": {
                "invalid_number": "The card number is not a valid credit card number.",
                "invalid_expiry_month": "The card's expiration month is invalid.",
                "invalid_expiry_year": "The card's expiration year is invalid.",
                "invalid_cvc": "The card's security code is invalid.",
                "invalid_swipe_data": "The card's swipe data is invalid.",
                "incorrect_number": "The card number is incorrect.",
                "expired_card": "The card has expired.",
                "incorrect_cvc": "The card's security code is incorrect.",
                "incorrect_zip": "The card's zip code failed validation.",
                "card_declined": "The card was declined.",
                "missing": "There is no card on a customer that is being charged.",
                "processing_error": "An error occurred while processing the card."
            },
            "charge_failure": {
                "reason": {
                    "approve_with_id": "approve_with_id",
                    "call_issuer": "call_issuer",
                    "card_not_supported": "card_not_supported",
                    "card_velocity_exceeded": "card_velocity_exceeded",
                    "currency_not_supported": "currency_not_supported",
                    "do_not_honor": "do_not_honor",
                    "do_not_try_again": "do_not_try_again",
                    "fraudulent": "fraudulent",
                    "generic_decline": "generic_decline",
                    "insufficient_funds": "insufficient_funds",
                    "invalid_account": "invalid_account",
                    "invalid_amount": "invalid_amount",
                    "invalid_inset-0": "invalid_inset-0",
                    "issuer_not_available": "issuer_not_available",
                    "lost_card": "lost_card",
                    "new_account_information_available": "new_account_information_available",
                    "no_action_taken": "no_action_taken",
                    "not_permitted": "not_permitted",
                    "pickup_card": "pickup_card",
                    "reenter_transaction": "reenter_transaction",
                    "restricted_card": "restricted_card",
                    "revocation_of_all_authorizations": "revocation_of_all_authorizations",
                    "revocation_of_authorization": "revocation_of_authorization",
                    "security_violation": "security_violation",
                    "service_not_allowed": "service_not_allowed",
                    "stolen_card": "stolen_card",
                    "stop_payment_order": "stop_payment_order",
                    "testmode_decline": "testmode_decline",
                    "transaction_not_allowed": "transaction_not_allowed",
                    "try_again_later": "try_again_later",
                    "withdrawal_count_limit_exceeded": "withdrawal_count_limit_exceeded"
                }
            },
            "identity_document": {
                "reason": {
                    "scan_corrupt": "Identity document file is corrupt.",
                    "scan_not_readable": "The identity document is not readable.",
                    "scan_failed_greyscale": "The identity document is greyscale.",
                    "scan_failed_test_mode": "The identity document was a testmode failure.",
                    "scan_not_uploaded": "No identity document was uploaded.",
                    "scan_id_type_not_supported": "That identity document type is not supported.",
                    "scan_id_country_not_supported": "The country for that identity document is not supported.",
                    "scan_name_mismatch": "The name on the identity document doesn't match the name on the account.",
                    "scan_failed_other": "The identity document failed verification.",
                    "failed_keyed_identity": "The account information and identity document could not be verified.",
                    "failed_other": "The identity document failed verification.",
                    "document_failed_test_mode": "The identity document failed test mode."
                }
            }
        },
        "notifications": [],
        "payment_intents": {
            "status": {
                "requires_payment_method": "Requires payment method",
                "requires_confirmation": "Requires confirmation",
                "requires_action": "Requires action",
                "processing": "Processing",
                "requires_capture": "Requires capture",
                "canceled": "Cancelled",
                "succeeded": "Succeeded"
            }
        },
        "nexmos": {
            "notifications": {
                "application": {
                    "application_submitted": "Application submitted {url}"
                },
                "job_sheet_contact": {
                    "job_sheet_entry_made": "{landlord} has updated your job sheet {url}",
                    "job_sheet_made": "{landlord} has a job for you {url}"
                },
                "landlord": {
                    "application_submitted": "Application submitted: {property} {url}",
                    "charge_requested": "Offline payment: Acknowledgement required for {amount} from {payer} ({properties}) {url}",
                    "fee_late": "Fee late: {amount} outstanding for '{fee}' ({property}) {url}",
                    "landlord_unverified": "Account verification: We failed to verify your account {url}",
                    "landlord_verified": "Account verification: Your account has been verified! {url}",
                    "landlord_reverify": "Account verification: Please reverify your account. Details have been emailed to you {url}",
                    "job_sheet_entry_made": "{contact} has updated their job sheet {url}",
                    "payment_made": "Money in: {amount} from {payer} ({properties}) {url}",
                    "payout_made": "Money out: {amount} has been transferred to your bank account {url}",
                    "rent_late": "Rent late: {amount} outstanding {rent} rent ({property}) {url}",
                    "residency_accepted": "Tenant invite: {tenant} has joined your tenancy ({property}) {url}",
                    "tenancy_periodised": "Tenancy rolled: Term is now periodic at {property} {url}"
                },
                "message": {
                    "message_made": "New message received {url}"
                },
                "residency": {
                    "residency_made": "Your tenancy invitation for {property} {url}"
                },
                "task": {
                    "custom_task": "Task reminder: {url}"
                },
                "tenant": {
                    "application_rejected": "Application rejected: Sorry, your application for {property} has been rejected {url}",
                    "charge_accepted": "Offline payment: {amount} you paid on {date} has been accepted ({properties}) {url}",
                    "charge_autogenous": "Offline payment: {amount} added by your landlord ({properties}) {url}",
                    "charge_failed": "Card payment failed: Unable to make a payment of {amount} ({properties}) {url}",
                    "charge_unconfirmed": "Card payment pending: Action required to complete a payment of {amount} ({properties}) {url}",
                    "charge_rejected": "Offline payment: Your payment of {amount} has been rejected ({properties}) {url}",
                    "fee_late": "Fee late: {amount} outstanding for '{fee}' ({property}) {url}",
                    "fee_owed": "Fee due: {amount} due today for '{fee}' ({property}) {url}",
                    "rent_extended": "Rent extended: {rent} rent is now due {date} ({property}) {url}",
                    "rent_late": "Rent late: {rent} rent is {diff} late. {amount} outstanding ({property}) {url}",
                    "rent_owed": "Rent due: {amount} due today for {rent} rent ({property}) {url}",
                    "rent_upcoming": "Rent reminder: {rent} rent is due in {days} days ({property}) {url}",
                    "fee_upcoming": "Fee reminder: {fee} fee is due in {days} days ({property}) {url}",
                    "tenancy_fee_made": "Fee created: {amount} for new fee '{fee}' ({property}) {url}",
                    "tenancy_periodised": "Tenancy rolled: Term is now periodic at {property} {url}"
                }
            }
        },
        "definitions": {
            "alert": {
                "landlord": {
                    "rent_late_alert_definition": {
                        "title": "{rent} rent is late.",
                        "description": "The rent due on {due_at_original} for \"{property}\" is late."
                    },
                    "fee_late_alert_definition": {
                        "title": "Fee for \"{fee}\" is late.",
                        "description": "The fee due on {due_at_original} for \"{fee}\" is late."
                    }
                },
                "tenant": {
                    "rent_late_alert_definition": {
                        "title": "{rent} rent is late.",
                        "description": "The rent due on {due_at_original} for \"{property}\" is late."
                    },
                    "fee_late_alert_definition": {
                        "title": "Fee for \"{fee}\" is late.",
                        "description": "The fee due on {due_at_original} for \"{fee}\" is late."
                    }
                }
            },
            "calendar_event": {
                "document_expires_calendar_event_definition": {
                    "title": "Document expires",
                    "description": "The document \"{document}\" expires."
                },
                "fee_due_calendar_event_definition": {
                    "title": "Fee due.",
                    "description": "The fee for \"{fee}\" is due."
                },
                "rent_due_calendar_event_definition": {
                    "title": "Rent due.",
                    "description": "{month} rent at {property} is due."
                },
                "tenancy_starts_calendar_event_definition": {
                    "title": "Tenancy starts.",
                    "description": "Tenancy at {property} starts."
                },
                "tenancy_ends_calendar_event_definition": {
                    "title": "Tenancy ends.",
                    "description": "Tenancy at {property} ends."
                }
            },
            "notification": {
                "landlord": {
                    "application_submitted_notification_definition": {
                        "title": "Listing application received",
                        "description": "Your listing for \"{property}\" has received a new application."
                    },
                    "charge_requested_notification_definition": {
                        "title": "Offline charge requested.",
                        "description": "An offline charge from {tenant} needs acknowledging."
                    },
                    "fee_late_notification_definition": {
                        "title": "A fee is late.",
                        "description": "The fee due on {due_at} for \"{title}\" is late."
                    },
                    "landlord_unverified_notification_definition": {
                        "title": "We couldn't activate your account.",
                        "description": "Please double-check the details you've entered and resubmit."
                    },
                    "landlord_verified_notification_definition": {
                        "title": "Your account has been verified!",
                        "description": "Welcome aboard! You can now begin inviting your tenants."
                    },
                    "payment_made_notification_definition": {
                        "title": "You have been paid",
                        "description": "We'll transfer the funds into your bank account soon."
                    },
                    "payout_made_notification_definition": {
                        "title": "You have been paid out.",
                        "description": "The available funds on your account have been transferred to your bank account."
                    },
                    "rent_late_notification_definition": {
                        "title": "{month} rent is late.",
                        "description": "The rent due on {due_at} for \"{property}\" is late."
                    },
                    "residency_accepted_notification_definition": {
                        "title": "Tenancy invitation accepted.",
                        "description": "{tenant} has accepted your tenancy invitation for \"{property}\"."
                    }
                },
                "tenant": {
                    "charge_accepted_notification_definition": {
                        "title": "Offline payment accepted.",
                        "description": "Your landlord has accepted the offline payment you made on {created_at}."
                    },
                    "charge_autogenous_notification_definition": {
                        "title": "Offline payment added.",
                        "description": "Your landlord has added an offline payment."
                    },
                    "charge_failed_notification_definition": {
                        "title": "Payment failed.",
                        "description": "We were unable to process your payment."
                    },
                    "charge_rejected_notification_definition": {
                        "title": "Offline payment rejected.",
                        "description": "Your landlord has rejected the offline payment you made on {created_at}"
                    },
                    "charge_succeeded_notification_definition": {
                        "title": "Payment succeeded.",
                        "description": "Your payment has succeeded!"
                    },
                    "charge_unconfirmed_notification_definition": {
                        "title": "Payment requires confirmation.",
                        "description": "Your payment has requires further action to complete."
                    },
                    "fee_late_notification_definition": {
                        "title": "A fee is late.",
                        "description": "The fee due on {due_at} for \"{title}\" is late."
                    },
                    "fee_owed_notification_definition": {
                        "title": "A fee is due.",
                        "description": "The fee for \"{title}\" is due today ({due_at})."
                    },
                    "rent_extended_notification_definition": {
                        "title": "January rent extended.",
                        "description": "Your landlord has extended {month} rent for \"{property}\". It is now due {due_at}."
                    },
                    "rent_late_notification_definition": {
                        "title": "{month} rent is late.",
                        "description": "The rent due on {due_at} for \"{property}\" is late."
                    },
                    "rent_owed_notification_definition": {
                        "title": "{month} rent is due.",
                        "description": "{month} rent for \"{property}\" is due today ({due_at})."
                    },
                    "residency_invite_notification_definition": {
                        "title": "You've been invited to join a tenancy.",
                        "description": "{landlord} has invited you to join a tenancy at \"{property}\"."
                    },
                    "tenancy_fee_made_notification_definition": {
                        "title": "A fee has been added.",
                        "description": "Your landlord has added a fee for \"{title}\" to your tenancy at \"{property}\"."
                    }
                }
            },
            "notification-preference": {
                "landlord": {
                    "application_submitted_notification_definition": {
                        "title": "New application has been submitted.",
                        "description": "A prospective tenant has submitted an application for one of your listings."
                    },
                    "charge_requested_notification_definition": {
                        "title": "An offline payment has been requested.",
                        "description": "Your tenant has added an offline payment that you must acknowledge."
                    },
                    "fee_late_notification_definition": {
                        "title": "A fee is late.",
                        "description": "Fees are considered late the morning after their due date."
                    },
                    "job_sheet_entry_made_notification_definition": {
                        "title": "A job sheet has been updated.",
                        "description": "When a contact leaves a comment on their job sheet."
                    },
                    "message_made_notification_definition": {
                        "title": "You've been sent a message.",
                        "description": "When someone contacts you via the messaging service."
                    },
                    "payment_made_notification_definition": {
                        "title": "A tenant has made a payment."
                    },
                    "rent_late_notification_definition": {
                        "title": "A rent is late.",
                        "description": "Rents are considered late the morning after their due date."
                    },
                    "residency_accepted_notification_definition": {
                        "title": "A tenant accepts my tenancy invitation."
                    },
                    "tenancy_periodised_notification_definition": {
                        "title": "A tenancy rolls from fixed to periodic.",
                        "description": "When a fixed tenancy reaches the end of it's term, and it rolls onto being periodic."
                    }
                },
                "tenant": {
                    "charge_accepted_notification_definition": {
                        "title": "My offline payment has been accepted.",
                        "description": "Your landlord needs to acknowledge recipt of offline payments."
                    },
                    "charge_autogenous_notification_definition": {
                        "title": "My landlord adds an offline payment.",
                        "description": "Your landlord can add offline payments on your behalf."
                    },
                    "charge_failed_notification_definition": {
                        "title": "My payment fails."
                    },
                    "charge_rejected_notification_definition": {
                        "title": "My offline payment has been rejected.",
                        "description": "Your landlord needs to acknowledge recipt of offline payments."
                    },
                    "charge_succeeded_notification_definition": {
                        "title": "My payment succeeds.",
                        "description": "The email serves as your receipt."
                    },
                    "charge_unconfirmed_notification_definition": {
                        "title": "My payment requires manual confirmation.",
                        "description": "Your payment has not confirmed yet."
                    },
                    "fee_late_notification_definition": {
                        "title": "A fee is late.",
                        "description": "Fees are considered late the morning after their due date."
                    },
                    "fee_owed_notification_definition": {
                        "title": "A fee is due.",
                        "description": "Fees are considered due the morning of their due date."
                    },
                    "message_made_notification_definition": {
                        "title": "You've been sent a message.",
                        "description": "When someone contacts you via the messaging service."
                    },
                    "rent_extended_notification_definition": {
                        "title": "A rent has been extended.",
                        "description": "Your landlord has extended the rent's due date."
                    },
                    "rent_late_notification_definition": {
                        "title": "A rent is late.",
                        "description": "Rents are considered late the morning after their due date."
                    },
                    "rent_owed_notification_definition": {
                        "title": "A rent is due.",
                        "description": "Rents are considered due the morning of their due date."
                    },
                    "rent_upcoming_notification_definition": {
                        "title": "An upcoming rent is due soon.",
                        "description": "A reminder 3 days before the rent is due."
                    },
                    "residency_invite_notification_definition": {
                        "title": "I'm invited to join a tenancy.",
                        "description": "Your landlord will invite you to join a tenancy."
                    },
                    "tenancy_fee_made_notification_definition": {
                        "title": "A fee is made for a tenancy.",
                        "description": "Your landlord has added a fee for something related to your tenancy."
                    },
                    "tenancy_periodised_notification_definition": {
                        "title": "A tenancy rolls from fixed to periodic.",
                        "description": "When a fixed tenancy reaches the end of it's term, and it rolls onto being periodic."
                    }
                }
            },
            "task": {
                "account_verification_task_definition": {
                    "title": "Verify your account.",
                    "description": "We need to collect some details from you before we're allowed to send you money."
                },
                "verify_email_task_definition": {
                    "title": "Verify your email address.",
                    "description": "We need to verify that you're the owner of the provided email."
                },
                "verify_telephone_task_definition": {
                    "title": "Verify your telephone number.",
                    "description": "We need to verify that you're the owner of the provided telephone number."
                },
                "add_auto_payment_to_tenancy_task_definition": {
                    "title": "Set-up smart payments.",
                    "description": "Avoid late payments by setting up smart payments for your tenancy at {property}."
                },
                "add_first_property_task_definition": {
                    "title": "Add your first property.",
                    "description": "First things first. Let's add your first property."
                },
                "add_tenancy_to_property_task_definition": {
                    "title": "Add tenancy to {property}.",
                    "description": "Add the first tenancy to your property."
                },
                "add_occupant_to_tenancy_task_definition": {
                    "title": "Add tenants to {tenancy}.",
                    "description": "Add tenants to your tenancy, we'll email them an invitation link."
                },
                "handle_offline_charge_task_definition": {
                    "title": "Accept or reject an offline payment.",
                    "description": "{tenant} has added an offline payment."
                }
            }
        },
        "subscriptions": {
            "plans": {
                "daily": "Daily Plan",
                "monthly": "Monthly Plan",
                "yearly": "Yearly Plan"
            },
            "non_countable_noun": {
                "daily": "Day",
                "monthly": "Month",
                "yearly": "Year"
            }
        },
        "residency": {
            "state": {
                "accepted": "Joined",
                "sent": "Invited",
                "created": "Not Invited"
            }
        },
        "payout": {
            "status": {
                "pending": "Pending",
                "in_transit": "In Transit",
                "paid": "Paid"
            }
        },
        "fee": {
            "punctual_state": {
                "upcoming": "Upcoming",
                "due": "Due",
                "late": "Late",
                "written_off": "Written-off",
                "completed": "Completed"
            }
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, and dashes.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "equal": "The {attribute} must equal {value}.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filesize": "The {attribute} may not be greater than {max} megabytes.",
            "filled": "The {attribute} field is required.",
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "json": "The {attribute} must be a valid JSON string.",
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "model": "The {attribute} field is required.",
            "mobile_telephone": "The {attribute} must be a valid mobile number.",
            "not_in": "The selected {attribute} is invalid.",
            "numeric": "The {attribute} must be a number.",
            "numeric_between": "The {attribute} must be a number between {min} and {max}.",
            "postcode": "The {attribute} must be a valid UK postcode.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} is present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "string": "The {attribute} must be a string.",
            "telephone_number": "The {attribute} must be a valid telephone number.",
            "timestamp": "The {attribute} must be a unix timestamp.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "upload": "The {attribute} must be a file of the type: {values}.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "user_inactive": "That account hasn’t been activated. We’ve just emailed you a link to activate it.",
            "youtube_url": "The {attribute} format is invalid.",
            "custom": {
                "date_of_birth": {
                    "date_format": "The {attribute} is not a valid date.",
                    "before": "The person must be older than {age}."
                },
                "percent_ownership": {
                    "equal": "The combined {attribute} between all persons must equal {value}%."
                },
                "account_opener_roles": {
                    "include": "The {attribute} must also be an execute or owner."
                },
                "listing": {
                    "unique": "You've already created a listing for this property."
                }
            },
            "attributes": {
                "tax_id": "CRN",
                "address.street": "line 1",
                "address.locality": "line 2",
                "address.village": "line 3",
                "address.town": "town",
                "address.county": "county",
                "address.postcode": "postcode",
                "data.*.first_name": "first name",
                "data.*.last_name": "last name",
                "data.*.date_of_birth": "date of birth",
                "data.*.email": "email",
                "data.*.telephone": "telephone",
                "data.*.job_title": "job title",
                "data.*.percent_ownership": "percent ownership",
                "data.*.address.street": "line 1",
                "data.*.address.locality": "line 2",
                "data.*.address.village": "line 3",
                "data.*.address.town": "town",
                "data.*.address.county": "county",
                "data.*.address.postcode": "postcode",
                "data.*.identity_document.front": "ID front",
                "data.*.identity_document.back": "ID back"
            }
        },
        "document": {
            "type": {
                "gas": "Gas Certificate",
                "legionaries": "Legionaries Certificate",
                "electrical": "Electrical Check",
                "contract": "Contract",
                "epc": "EPC",
                "insurance": "Insurance",
                "right_to_rent": "Right to Rent Document",
                "other": "Other"
            }
        },
        "tenancy": {
            "term": {
                "periodic": "Periodic",
                "fixed": "Fixed"
            }
        },
        "objects": {
            "landlord": "Landlord",
            "tenant": "Tenant"
        },
        "auth": {
            "failed": "These credentials do not match our records.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds."
        },
        "notify": {
            "auth": {
                "logout": {
                    "title": "See you soon!",
                    "message": "You have been successfully logged out."
                }
            },
            "register_confirm": {
                "confirmed": {
                    "type": "success",
                    "title": "Email confirmed",
                    "message": "Thanks for confirming your email address!"
                },
                "login_first": {
                    "type": "error",
                    "title": "Failed to confirm email",
                    "message": "Please login first."
                },
                "token_not_found": {
                    "type": "error",
                    "title": "Failed to confirm email",
                    "message": "Could not find the email confirmation token. It may have been used already or expired."
                },
                "unauthorized": {
                    "type": "error",
                    "title": "Failed to confirm email",
                    "message": "You're not authorized to do that!"
                }
            }
        },
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "passwords": {
            "password": "Passwords must be at least six characters and match the confirmation.",
            "reset": "Your password has been reset!",
            "sent": "We have c-mailed your password reset link!",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that c-mail address."
        }
    }
}
